import React, { useState } from 'react';
import { Layout, Menu, Avatar, Dropdown, Typography, Button, theme } from 'antd';
import {
  TeamOutlined,
  ShoppingCartOutlined,
  MessageOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  LogoutOutlined,
} from '@ant-design/icons';

const { Header, Sider, Content } = Layout;

export default function DashboardLayout({
  activeKey = 'doctors',
  onChange = () => {},
  onLogout = () => {},
  children,
}) {
  const [collapsed, setCollapsed] = useState(false);
  const { token } = theme.useToken();

  const accountMenu = {
    items: [
      { key: 'profile', icon: <UserOutlined />, label: 'Profil' },
      { type: 'divider' },
      { key: 'logout', icon: <LogoutOutlined />, label: 'Déconnexion', danger: true },
    ],
    onClick: ({ key }) => {
      if (key === 'logout') onLogout();
    },
  };

  const menuItems = [
    { key: 'doctors', icon: <TeamOutlined />, label: 'Doctors' },
    { key: 'products', icon: <ShoppingCartOutlined />, label: 'Products' },
    { key: 'feedbacks', icon: <MessageOutlined />, label: 'Feedbacks' },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        collapsible
        trigger={null}
        collapsed={collapsed}
        width={240}
        style={{
          background: token.colorBgContainer,
          borderRight: `1px solid ${token.colorSplit}`,
        }}
      >
        <div
          onClick={() => onChange('doctors')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            height: 64,
            padding: '0 12px',
            cursor: 'pointer',
          }}
        >
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: 10,
              background: '#3B82F6',
              color: '#fff',
              display: 'grid',
              placeItems: 'center',
            }}
          > 
          </div>
          {!collapsed && <span style={{ fontWeight: 800 }}>MEDILINK</span>}
        </div>

        <Menu
          mode="inline"
          selectedKeys={[activeKey]}
          onClick={({ key }) => onChange(key)}
          items={menuItems}
          style={{ borderInlineEnd: 0 }}
        />
      </Sider>

      <Layout>
        <Header
          style={{
            background: token.colorBgContainer,
            borderBottom: `1px solid ${token.colorSplit}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingInline: 16,
            position: 'sticky',
            top: 0,
            zIndex: 99,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
            />
            <Typography.Text strong style={{ fontSize: 16 }}>
              Dashboard
            </Typography.Text>
          </div>

          <Dropdown menu={accountMenu} placement="bottomRight" trigger={['click']}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
              <Avatar size="small" icon={<UserOutlined />} />
              <Typography.Text className="hide-sm">Admin</Typography.Text>
            </div>
          </Dropdown>
        </Header>

        <Content
          style={{
            padding: 16,
            background:
              'radial-gradient(800px 400px at -10% -10%, #f1f5f9 0%, transparent 60%), radial-gradient(700px 350px at 110% 0%, #fce7f3 0%, transparent 60%), linear-gradient(180deg, rgba(0,0,0,0.02), rgba(0,0,0,0.03))',
            minHeight: 'calc(100vh - 64px)',
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
}